import InfinityLoader from '@/components/common/infinityLoader'
import SelectQualification from '@/components/common/select/SelectQualification'
import SelectProfession from '@/components/common/select/SelectUserProfession'
import SelectUserSpecialty from '@/components/common/select/SelectUserSpecialty'
import { Education } from '@/types/graphql/types'
import { Button, Group, LoadingOverlay, TextInput } from '@mantine/core'
import { DatePicker } from '@mantine/dates'
import useTranslation from 'next-translate/useTranslation'
import useEducationForm from '@/hooks/Dashoboard/Members/Profile/Education/useEducationForm'

const EducationForm = ({
  education,
  handleUpdateEducations,
}: {
  education: Education | null
  handleUpdateEducations: ({
    newEducations,
  }: {
    newEducations: Education[]
  }) => void
}) => {
  const { t } = useTranslation('common')
  const { form, submit, loading } = useEducationForm({
    education,
    handleUpdateEducations,
  })
  return (
    <form onSubmit={form.onSubmit(submit)} className="relative">
      <LoadingOverlay
        loader={<InfinityLoader variant="lg" />}
        visible={loading}
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <TextInput
          label={t('university')}
          {...form.getInputProps('university')}
          required
        />
        <DatePicker
          label={t('graduationYear')}
          {...form.getInputProps('graduationYear')}
          required
        />
        <SelectProfession
          inputProps={form.getInputProps('profession')}
          required
        />
        <SelectUserSpecialty
          inputProps={form.getInputProps('specialty')}
          professionId={form.values.profession ? +form.values.profession : null}
          required
        />
        <SelectQualification
          inputProps={form.getInputProps('qualification')}
          required
        />
      </div>
      <Group position="center" pt={10}>
        <Button type="submit">{t('save')}</Button>
      </Group>
    </form>
  )
}

export default EducationForm
